import { strToFloatStr } from './validators/validate.js';
export function selectSymbol(id, name, symbol, currency, type, oz) {
	if (!symbol) symbol = '-';
	$('#portfolio-data-input').css('display', 'block');
	$('#alert_stockname').html(name);
	selectors.setSelectedAsset(id);
	$('#alert_stockid').html(symbol);
	$('.asset-currency').each(function () { $(this).val(currency); });
	$('#asset_type').html(type);
	$('#live-fast-search-results').hide();
	$('#live-search-results').hide();
	$('#deep-search-area').hide();
	$('#assetSelection').show();
	$('#searchstring').val('');
	$('#oz-sign').css('display', 'none');
	if (oz.toString() == 'true') $('#oz-sign').css('display', 'block');
}

export function checkInput(value, target, def) {
	var parsed = parseFloat(strToFloatStr(value));
	if (!parsed) {
		$('#' + target).val(def);
		return 0;
	} else {
		$('#' + target).val(formatNumberForLocale(parsed));
	}
}

/* format a JS number into the active locale (thousands + decimal separator) */
export function formatNumberForLocale(num) {
	var decSeperator = I18n['dec_seperator'];
	var thousandSeperator = I18n['thousand_seperator'];
	var parts = num.toString().split('.');
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeperator);
	return parts[1] ? parts[0] + decSeperator + parts[1] : parts[0];
}

export function getAssetByAlerts(id) {
	for (var i = 0; i < useralerts.length; i++) {
		if (useralerts[i]['assetid'] == id) return i;
	}
}

export function getAssetByAssets(id) {
	for (var i = 0; i < userassets.length; i++) {
		if (userassets[i]['id'] == id) return i;
	}
}

export function getTotalItems() {
	return userassets.length;
}

String.prototype.replaceAll = function (search, replacement) {
	var target = this;
	return target.replace(new RegExp(search, 'g'), replacement);
};

export function sortByName(a, b) { return a.localeCompare(b); }

String.prototype.toCurrencySymbol = function () {
	if (this.toUpperCase() == 'EUR') {
		return '€';
	}
	if (this.toUpperCase() == 'USD') {
		return '$';
	}
	return this;
};


/* Auto resize textareas */
var taAutoResize = function (element, __content) {
	if (element) {
		element.style.height = 'auto';
		var content = '';
		if (__content !== undefined) content = __content;
		else content = element.value;

		var parent = $(element).parent();
		var random = Math.random().toString().split('.')[1];
		var virtual = '<div id="fake-ta'+ random +'" class="' + element.className + '"></div>';
		$(parent).append(virtual);
		var virtual_ref = '#fake-ta'+random;
		$(virtual_ref).css('visibility', 'hidden');
		$(virtual_ref).css('display', 'none');
		$(virtual_ref).css('height', 'fit-content');
		$(virtual_ref).css('white-space', 'pre-wrap');
		$(virtual_ref).text(content);

		$(virtual_ref).ready(function() {
			$(virtual_ref).css('visibility', 'hidden');
			$(virtual_ref).css('display', 'none');
			$(virtual_ref).text(content);
			var height = Math.min($(virtual_ref).innerHeight() + 10, 140);
			height = Math.max(height, 50);
			$(element).css('min-height',parseInt(height)+'px');
			element.style.resize = 'none';
			$(virtual_ref).remove();
		});
	};
};

var assetNoteTimerListen = false;

export function cleanSpacesAndPragraphs(__this) {
	var $this = $(__this),
		val = $(__this).val()
			.replace(/(\r\n|\n|\r)/gm, ' ') // replace line breaks with a space
			.replace(/ +(?= )/g, ''); // replace extra spaces with a single space
	$this.val(val);
}